import React from 'react';
import { Map, List } from 'immutable';

import { PreviewValue } from '../Editor';
import { UserSimple as User, MessageTemplate } from '~/types/models';
import { AttributeListValue, AttributeValue, EmbedService } from '../../Types';

export default React.createContext<EditorContextProps>({
  state: Map(),
  set: () => undefined,
  get: () => undefined,
  hasUpdated: false,
  setHasUpdated: () => false,
});

export type EditorContextGet = <T extends AttributeValue | AttributeListValue>(
  key: string | string[],
  defaultValue?: T
) => T | undefined;

export interface EditorContextProps {
  user?: User;
  state: Map<unknown, unknown>;
  metadata?: Metadata;
  compiledTemplates?: {
    subjectLine: string;
    message: React.ReactNode;
  };
  set: <T>(key: string | number, value: T) => void;
  get: EditorContextGet;

  preview?: PreviewValue;
  setCta?: ({ text, uri }: { text?: string; uri?: string }) => void;
  hasChanges?: boolean;
  hasUpdated: boolean;
  setHasUpdated: (updated: boolean) => void;
  setApiState?: (res: MessageTemplate) => void;
  embedServices?: List<EmbedService>;
}

export interface Metadata {
  defaultMessage: string;
  defaultSubjectLine: string;
  playerImage?: string;
}
